<bc-footer componentId="footer-component" [isBancoLogoBottom]="true" [isBancoIsotipoBottom]="false"
    [isVigilaLogoBottom]="true"  [bottomTextLeftContent]="[
  'Copyright © 2026 Bancolombia.'
]" [socialNetBottomRight]="[
  {
    'name': 'whatsapp',
    'link': 'https://wa.me/573013536788'
  },
  {
    'name': 'facebook',
    'link': 'https://www.facebook.com/bancolombia'
  },
  {
    'name': 'linkedin',
    'link': 'https://www.linkedin.com/company/22690'
  },
  {
    'name': 'instagram',
    'link': 'https://instagram.com/bancolombia'
  },
  {
    'name': 'youtube',
    'link': 'https://www.youtube.com/user/GrupoBancolombia'
  }
]" [bottomTextRighContent]="[
  'Dirección IP ' + directionIP,
  'Última visita ' + lastSesion
]">
</bc-footer>